import { Minus, Plus, Trash2, Type } from "lucide-react";
import InkPicker, { INK_COLORS } from "@/components/shirts/InkPicker";

export const TEXT_FONTS = [
    "Anton", "Bebas Neue", "Archivo Black", "Oswald", "Montserrat", "Inter", "Playfair Display", "Alfa Slab One",
    "Black Ops One", "Bangers", "Bungee", "Righteous", "Fredoka", "Permanent Marker", "Pacifico", "Lobster",
    "Dancing Script", "Rye", "Special Elite", "Creepster", "Monoton", "Press Start 2P", "JetBrains Mono",
];
export { INK_COLORS };

/** Text layers on the side you are looking at: add, type, pick a font and ink, nudge the size up or down. */
export default function TextPanel({ texts, addText, setText, removeText, selected, onSelect, theme }) {
    const btn = "grid h-6 w-6 place-items-center rounded-full border border-zinc-300 text-zinc-700 hover:border-zinc-500";
    return (
        <div className="space-y-2 p-1" data-testid="text-panel">
            <button type="button" onClick={() => onSelect(addText())} data-testid="add-text-btn"
                className="inline-flex w-full items-center justify-center gap-1.5 rounded-lg py-2 text-xs font-bold uppercase tracking-wide"
                style={{ background: theme?.primary, color: theme?.on }}>
                <Type size={14} /> Add text
            </button>
            {texts.length === 0 && (
                <p className="px-1 text-[11px] leading-snug text-zinc-500">Letters you can drag anywhere on the garment. A side with text counts as a print location.</p>
            )}

            {texts.map((t, i) => (
                <div key={i} onClick={() => onSelect(i)} data-testid={`text-layer-${i}`}
                    className="space-y-2 rounded-lg border bg-white p-2 transition-colors"
                    style={{ borderColor: selected === i ? theme?.primary : "#e4e4e7" }}>
                    <div className="flex items-center gap-2">
                        <input value={t.text} onChange={(e) => setText(i, { ...t, text: e.target.value })} placeholder="Your text" data-testid={`text-input-${i}`}
                            className="min-w-0 flex-1 rounded-md border border-zinc-300 bg-white px-2.5 py-1.5 text-sm text-zinc-900 outline-none"
                            onFocus={(e) => (e.target.style.borderColor = theme?.primary)} onBlur={(e) => (e.target.style.borderColor = "")} />
                        <span className="flex items-center gap-1" data-testid={`text-size-${i}`}>
                            <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-zinc-500">Size</span>
                            <button type="button" className={btn} onClick={() => setText(i, { ...t, heightIn: Math.max(0.5, Math.round((t.heightIn - 0.25) * 100) / 100) })} data-testid={`text-smaller-${i}`}><Minus size={11} /></button>
                            <button type="button" className={btn} onClick={() => setText(i, { ...t, heightIn: Math.round((t.heightIn + 0.25) * 100) / 100 })} data-testid={`text-bigger-${i}`}><Plus size={11} /></button>
                        </span>
                        <button type="button" onClick={() => removeText(i)} className="rounded-full border border-zinc-200 p-1.5 text-zinc-500 hover:text-red-600" data-testid={`text-remove-${i}`}><Trash2 size={13} /></button>
                    </div>

                    <div className="grid max-h-28 grid-cols-3 gap-1 overflow-y-auto pr-0.5" data-testid={`text-fonts-${i}`}>
                        {TEXT_FONTS.map((f) => (
                            <button key={f} type="button" onClick={() => setText(i, { ...t, font: f })} title={f}
                                style={{ fontFamily: `'${f}'`, ...(t.font === f ? { borderColor: theme?.primary, color: theme?.ink || theme?.primary } : {}) }}
                                className="truncate rounded-md border border-zinc-200 px-1.5 py-1 text-[11px] leading-4 text-zinc-700 transition-colors hover:bg-zinc-50"
                                data-testid={`text-font-${i}-${f.replace(/\s+/g, "-")}`}>{f}</button>
                        ))}
                    </div>

                    <InkPicker value={t.color} onChange={(c) => setText(i, { ...t, color: c })} theme={theme} testid={`text-color-${i}`} />
                </div>
            ))}
        </div>
    );
}
